<template>
  <div class="messageTip" v-if="visble">
    <div class="main">
      <div class="title">{{ title }}</div>
      <div id="imgCode"></div>
    </div>
  </div>
</template>

<script>
export default {
  // props:['message','show'],
  data() {
    return {
      visble: true,
    };
  },
  methods: {
    closeMsg() {
      this.visble = false;
    },
    showMsg() {
      this.visble = true;
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../assets/less/global.less';
#imgCode {
  /deep/ .nc_wrapper {
    width: 280 * @base;
  }
}
.messageTip {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.5);
  .main {
    width: 280 * @base;
    height: 100 * @base;
    padding: 20 * @base 20 * @base 10 * @base;
    border-radius: 6 * @base;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 20%;
    transform: translate3d(-50%, -50%, 0);
    .title {
      width: 100%;
      text-align: center;
      margin-bottom: 30 * @base;
    }
    p {
      padding-bottom: 10 * @base;
      font-size: 16 * @base;
      line-height: 24 * @base;
      text-align: center;
      color: #333;
      word-break: break-all;
    }
    .btn_box {
      display: flex;
      justify-content: center;
      align-items: center;

      // border-top: 1px solid #e5e5e5;
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16 * @base;
        height: 40 * @base;
        color: #e60000;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/popup/popups.vue